import { render, staticRenderFns } from "./edit-layer.vue?vue&type=template&id=04667d46&scoped=true"
import script from "./edit-layer.vue?vue&type=script&lang=js"
export * from "./edit-layer.vue?vue&type=script&lang=js"
import style0 from "./edit-layer.vue?vue&type=style&index=0&id=04667d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04667d46",
  null
  
)

export default component.exports